import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated } from '../services/authService.js'; 
import Home from '../components/Home.vue';
import About from '../components/About.vue';
import Packages from '../components/Packages.vue';
import SetupPassword from '../components/SetupPassword.vue';
import Login from '../components/Login.vue';
import Register from '../components/Register.vue';
import UserDashboard from '../components/Dashboard/User/Dashboard.vue';
import UserProfile from '../components/Dashboard/User/EditProfile.vue';
import AdminProfile from '../components/Dashboard/Admin/EditProfile.vue';
import CreatePackageForm from '../components/Dashboard/Admin/CreatePackageForm.vue';
import OrganizationProfile from '../components/Dashboard/Organization/EditProfile.vue';
import OrgDashboard from '../components/Dashboard/Organization/Dashboard.vue';
import AdminDashboard from '../components/Dashboard/Admin/Dashboard.vue';
import TestEnvironment from '../components/TestEnvironment.vue';
import FAQ from '../components/FAQ.vue';
import ForgotPassword from '../components/ForgotPassword.vue';
import Contact from '../components/Contact.vue';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import TermsOfUse from '../components/TermsOfUse.vue';
import Unauthorized from '../components/Unauthorized.vue';
// import MemberPassword from '../components/Dashboard/MemberPassword.vue';
import DefaultLayout from "@/DefaultLayout.vue"; // Default layout (not explicitly used)
import UserDashboardLayout from "@/components/Dashboard/User/DashboardLayout.vue"; 
import AdminDashboardLayout from "@/components/Dashboard/Admin/DashboardLayout.vue"; 
import OrganizationDashboardLayout from "@/components/Dashboard/Organization/DashboardLayout.vue"; 
import DashboardLayout from "@/components/Dashboard/DashboardLayout.vue"; 
import MockTest from '@/components/Dashboard/User/MockTest.vue';
import ManageTest from '@/components/Dashboard/User/ManageTest.vue';
// import TestStartScreen from '@/components/Dashboard/User/TestStartScreen.vue';
import TestResults from '@/components/Dashboard/User/TestResults.vue';
import UserVerification from '@/components/UserVerification.vue';
import RegisteredUserDetails from '@/components/Dashboard/Admin/RegisteredUserDetails.vue';
import QuestionsDetails from '@/components/Dashboard/Admin/QuestionsDetails.vue';
import ManageTestimonials from '@/components/Dashboard/Admin/ManageTestimonials.vue';
import OrgTestResults from '@/components/Dashboard/Organization/TestResults.vue'
import OrgUsers from '@/components/Dashboard/Organization/OrgUsers.vue';
import UserUpload from '@/components/Dashboard/Organization/UserUpload.vue';
import UserResults from '@/components/Dashboard/UserResults.vue';
import ManageResult from '@/components/Dashboard/ManageResult.vue';
import RetentionPackage from '@/components/RetentionPackage.vue';
import Checkout from '@/components/Dashboard/User/Checkout.vue';


  const routes = [
      {
        path: '/',
        component: DefaultLayout,
        children: [
          { path: '/', component: Home },
          { path: '/about', component: About },
          { path: '/packages', component: Packages },
          { path: '/retention-package', component: RetentionPackage },
          { path: '/login', component: Login, name: 'Login' },
          { path: '/register', component: Register },
          { path: '/setup-password', component: SetupPassword },
          { path: '/test-environment', component: TestEnvironment, meta: { requiresAuth: true }},
          { path: '/faq', component: FAQ },
          { path: '/contact', component: Contact },
          { path: '/privacy-policy', component: PrivacyPolicy },
          { path: '/terms-of-use', component: TermsOfUse },
          { path: '/forgot-password', component: ForgotPassword },
          { path: '/unauthorized', component: Unauthorized, name: 'Unauthorized' },
          { path: '/user-verification/:token', component: UserVerification, name: 'UserVerification' }
          
        ]
      },
      {
        path: "/dashboard",
        component: DashboardLayout,
        meta: { requiresAuth: true },
        children: [
          {
            path: "user",
            component: UserDashboardLayout,
            meta: { requiresAuth: true, allowedRoles: ["member"] },
            children: [
              { path: "home", component: UserDashboard },
              { path: "mock-test/:subscription_id/:user_id/:test_type", component: MockTest },
              { path: "manage-test", component: ManageTest } ,
              { path: "test-results/:id", component: TestResults } ,
              { path: "profile", component: UserProfile }
            ]
          },
          {
            path: "admin",
            component: AdminDashboardLayout,
            meta: { requiresAuth: true, allowedRoles: ["admin"] },
            children: [
              { path: "home", component: AdminDashboard, },
              { path: "registered-user-details", component: RegisteredUserDetails, },
              { path: "question-details", component: QuestionsDetails, },
              { path: "manage-testimonials", component: ManageTestimonials, },
              { path: "profile", component: AdminProfile, },
              { path: "add-package", component: CreatePackageForm},
              { path: "view-results/:user_id", component: ManageResult, },
              { path: "result/:id", component: UserResults, }
            ]
          },
          {
            path: "organization", 
            component: OrganizationDashboardLayout,
            meta: { requiresAuth: true, allowedRoles: ["manager"] },
            children: [
              { path: "home", name: "OrgDashboard", component: OrgDashboard, },
              { path: "user-upload", component: UserUpload, },
              { path: "org-users", component: OrgUsers, },
              { path: "test-results", component: OrgTestResults, },
              { path: "profile", component: OrganizationProfile, },
              { path: "view-results/:user_id", component: ManageResult, },
              { path: "result/:id", component: UserResults, }
            ]
          },
        ]
      },  
      { path: '/test-environment/:subscription_id/:user_id/:attemptNumber/:test_type', component: TestEnvironment, meta: { requiresAuth: true }},
      // Add a catch-all route for undefined paths
      { path: '/:pathMatch(.*)*', redirect: '/' },
      // Add this to your routes array under the dashboard/user routes
      {
        path: '/checkout/:packageId',
        name: 'Checkout',
        component: Checkout,
        meta: { requiresAuth: true }
      }
      
      // Example full router configuration structure:
      /*
      {
        path: '/dashboard/user',
        component: UserDashboardLayout,
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'UserDashboard',
            component: Dashboard
          },
          {
            path: 'profile',
            name: 'UserProfile',
            component: Profile
          },
          // Add this checkout route
          {
            path: '/checkout/:packageId',
            name: 'Checkout',
            component: Checkout,
            meta: { requiresAuth: true }
          }
        ]
      }
      */
  ];

const router = createRouter({
    history: createWebHistory(),
    routes,

    scrollBehavior(to, from, savedPosition) {
      // Always scroll to top unless restoring a saved position
      if (savedPosition) {
        return savedPosition; // when using browser back/forward
      } else {
        return { top: 0 }; // scroll to top for all route navigations
      }
    },
});

router.beforeEach(async (to, from, next) => {
  document.title = 'COLREGs'
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const res = await isAuthenticated();
    if (res.authenticated) {
      const userRole = res.user.role;
      if (to.meta.allowedRoles && !to.meta.allowedRoles.includes(userRole)) {
        next({ name: 'Unauthorized' }); // Redirect to an unauthorized page
      } else {
        next(); // Allow access
      }
    } else {
      next({ name: 'Login', query: { redirect: to.fullPath } });
    }
  } else {
    next();
  }
});

export default router;